import React, {Component} from 'react';
import Modal from 'react-modal';
import firebase from 'firebase';
import Alert from 'react-s-alert';

const database=firebase.database();

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px'
	
  }
};


class ModalTipos extends Component{
	
	
	constructor(props){
		
		super(props);
		
		this.state={
			isActive:false
		}
		
		this.tiposRef=database.ref().child('tipo_calificaciones');
		this.toggleModal=this.toggleModal.bind(this);
		this.handleSubmit=this.handleSubmit.bind(this);
		
	}
	
	
	
	
	componentDidMount(){
		
		
	}
	
	
	
	toggleModal(){
	
		
		this.setState({
			
			isActive:!this.state.isActive
			
		})
		
	}
	
	handleSubmit(event){
		
		
		let tipo=this.tipo.value;
		
			
		this.tiposRef.push({
			
			nombre:tipo,
			estado:'Activo'
		
		})
		
	
		this.toggleModal;
		
		Alert.success('Datos guardados correctamente', {
			effect: 'genie',
			position: 'bottom-right',
			timeout:2000			
		});
		
	
		
		this.toggleModal();
		
		
		event.preventDefault()
		
	}
	
	
	render(){
		
		return(
		
		
		
		
			<div className="modal_tipo">
							
					<button className="btn btn-primary" onClick={this.toggleModal}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
					
					
					<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles}>
					
					

						<form method="POST" onSubmit={this.handleSubmit}>
					
						<h3>Agregar tipo de calificación</h3>
						
						<hr/>
						
						
						
						
						<div className="form-group">
							<label>Tipo de calificación</label>
							<input type="text" className="form-control" required  placeholder="Tipo" autoComplete="off"
								ref={input=>{this.tipo=input}} 
							/>						
						</div>
						
						
						
							<button type="submit" className="btn btn-primary buttons" >Guardar</button>
						</form>
							<button type="button" className="btn btn-default buttons  btnmargin" onClick={this.toggleModal}>Cerrar</button>	
						
						
					</Modal>

					
					
			
			</div>
		
		);
		
		
	}
	
	
}

export default ModalTipos;


// WEBPACK FOOTER //
// ./src/Components/Calificaciones1/ModalTipos.js